// extracted by mini-css-extract-plugin
export var active = "_36-7";
export var container = "_36-0";
export var evenWidth = "_36-4";
export var large = "_36-5";
export var outlet = "_36-8";
export var slide = "_36-2";
export var small = "_36-6";
export var tab = "_36-3";
export var tabs = "_36-1";